import { Injectable } from "@angular/core";


@Injectable()
export class Globals {

   secret:string = 'encryptar';
   param_commerce: string;
   lat: string = '';
   lng: string = '';
   disabled: boolean = true;
   nombreCalle: string;
   
   address_map: string;
   cp_map: string;
   puerta_map: string;
   number_map: string;

   showPred: boolean = false;
}